/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_5_AInputs */

const en_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You review and explicitly approve each final submission.`)
};

const de_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du prüfst und gibst jede endgültige Einreichung ausdrücklich frei.`)
};

const fr_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous examinez et approuvez explicitement chaque soumission finale.`)
};

const es_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisas y apruebas explícitamente cada envío final.`)
};

const it_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rivedi e approvi esplicitamente ogni invio finale.`)
};

const nl_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je beoordeelt en keurt elke definitieve indiening expliciet goed.`)
};

const pl_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdzasz i wyraźnie zatwierdzasz każde ostateczne wysłanie.`)
};

const fi_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkistat ja hyväksyt nimenomaisesti jokaisen lopullisen lähetyksen.`)
};

const da_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du gennemgår og godkender udtrykkeligt hver endelig indsendelse.`)
};

const sv_landing_faq_5_a = /** @type {(inputs: Landing_Faq_5_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du granskar och godkänner uttryckligen varje slutlig inskickning.`)
};

/**
* | output |
* | --- |
* | "You review and explicitly approve each final submission." |
*
* @param {Landing_Faq_5_AInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_5_a = /** @type {((inputs?: Landing_Faq_5_AInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_5_AInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_5_a(inputs)
	if (locale === "fr") return fr_landing_faq_5_a(inputs)
	if (locale === "es") return es_landing_faq_5_a(inputs)
	if (locale === "it") return it_landing_faq_5_a(inputs)
	if (locale === "nl") return nl_landing_faq_5_a(inputs)
	if (locale === "pl") return pl_landing_faq_5_a(inputs)
	if (locale === "fi") return fi_landing_faq_5_a(inputs)
	if (locale === "da") return da_landing_faq_5_a(inputs)
	if (locale === "sv") return sv_landing_faq_5_a(inputs)
	return en_landing_faq_5_a(inputs)
});